import { render, staticRenderFns } from "./newShifts.vue?vue&type=template&id=0bf9a618&"
import script from "./newShifts.vue?vue&type=script&lang=js&"
export * from "./newShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports